// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.drag-layer_drag-layer_Zeafe {
  position: fixed;
  pointer-events: none;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  direction: ltr;
}

.drag-layer_image-wrapper_FYGO4 {
  /* Absolute allows wrapper to snuggly fit image */
  position: absolute;
}

.drag-layer_image_w89Qa {
  max-width: 80px;
  max-height: 80px;
  min-width: 50px;
  min-height: 50px;

  /* Center the dragging image on the given position */
  margin-left: -50%;
  margin-top: -50%;

  padding: 0.25rem;
  border: 2px solid var(--looks-secondary);
  background: var(--ui-white);
  border-radius: 0.5rem;

  /* Use the same drop shadow as stage dragging */
  box-shadow: 5px 5px 5px var(--shadow);
}
`, "",{"version":3,"sources":["webpack://./src/components/drag-layer/drag-layer.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;EACE,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;;EAEhB,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;;EAEhB,gBAAgB;EAChB,wCAAwC;EACxC,2BAA2B;EAC3B,qBAAqB;;EAErB,+CAA+C;EAC/C,qCAAqC;AACvC","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.drag-layer {\n  position: fixed;\n  pointer-events: none;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  direction: ltr;\n}\n\n.image-wrapper {\n  /* Absolute allows wrapper to snuggly fit image */\n  position: absolute;\n}\n\n.image {\n  max-width: 80px;\n  max-height: 80px;\n  min-width: 50px;\n  min-height: 50px;\n\n  /* Center the dragging image on the given position */\n  margin-left: -50%;\n  margin-top: -50%;\n\n  padding: 0.25rem;\n  border: 2px solid var(--looks-secondary);\n  background: var(--ui-white);\n  border-radius: 0.5rem;\n\n  /* Use the same drop shadow as stage dragging */\n  box-shadow: 5px 5px 5px var(--shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drag-layer": `drag-layer_drag-layer_Zeafe`,
	"dragLayer": `drag-layer_drag-layer_Zeafe`,
	"image-wrapper": `drag-layer_image-wrapper_FYGO4`,
	"imageWrapper": `drag-layer_image-wrapper_FYGO4`,
	"image": `drag-layer_image_w89Qa`
};
export default ___CSS_LOADER_EXPORT___;
